import { AlertIconVariant } from '../../../structure';
import { CreateDecisions } from '../../types';

export const createAlertIconDecisions: CreateDecisions<AlertIconVariant> = ({ decisions }) => ({
    backgroundColor: {
        value: decisions.backgroundColor.semantic.info,
        variant: {
            success: {
                value: decisions.backgroundColor.semantic.success,
            },
            warning: {
                value: decisions.backgroundColor.semantic.warning,
            },
            error: {
                value: decisions.backgroundColor.semantic.destructive,
            },
        },
    },
    color: {
        value: decisions.textColor.onSemanticBackground.light,
        variant: {
            warning: {
                value: decisions.textColor.onSemanticBackground.dark,
            },
        },
    },
});
